import { createContext, type ReactNode, useContext } from 'react';

export type TrackProperties = Record<string, string | number | boolean>;
export type TrackFn = (event: string, properties?: TrackProperties) => void;

const noop: TrackFn = () => {};

const TrackingContext = createContext<TrackFn>(noop);

export function TrackingProvider({
  track,
  children,
}: {
  track: TrackFn;
  children: ReactNode;
}): ReactNode {
  return <TrackingContext.Provider value={track}>{children}</TrackingContext.Provider>;
}

export function useTracking(): TrackFn {
  return useContext(TrackingContext);
}
